





























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import { MSResponse } from '@/interfaces/MS';
import { LoadingService } from '@/services/loadingService';
import TorreControlInstance from '@/pantallas/TorreControl/comunes/Instances';
import { DispositivosService } from '@/pantallas/TorreControl/ControlDispositivos/dispositivosService';

@Component({
  components: {
    //FlotaFilterAutocomplete,
  },
})
export default class certificadoDispositivo extends Vue {
  headers: string[];
  desserts: string[];
  idCamara: string = '';
  step: number = 0;
  clientId: string = '';
  isLoading: boolean = false;
  $snotify: any;
  dataPdf: any = {};
  tipo: string = '';
  dispositivosService = new DispositivosService();

  isDialogOpen: boolean = false;
  isClosed: boolean = false;
  pdfObject: string = '';
  $notify: any;

  readonly loadingService = new LoadingService();

  mounted() {
    let _self = this;
    this.clientId = localStorage.getItem('clienteDefecto');
    TorreControlInstance.$off('openCertificate');
    TorreControlInstance.$on('openCertificate', function(data: any) {
      _self.dataPdf = data;
      _self.open();
    });
  }

  async open() {
    let self = this;
    this.isDialogOpen = true;
    this.isClosed = false;
    if (this.dataPdf.infoVehiculo.esquema_bd == 'anglo') this.tipo = '36';
    else this.tipo = '35';
    this.isLoading = true;
    this.loadingService.showLoading();
    const axiosResponse: AxiosResponse<
      MSResponse<any>
    > = await this.dispositivosService.getCertificadoPdf(
      this.clientId,
      this.dataPdf.patente,
      this.dataPdf,
      this.tipo
    );
    this.isLoading = false;
    const msRespose: any = axiosResponse.data;
    if (msRespose.CODIGO_RESPUESTA == '1') {
      this.pdfObject = msRespose.url;
    } else {
      this.pdfObject = '';
      this.$snotify.error(msRespose.MENSAJE_RESPUESTA);
      this.loadingService.hideLoading();
      this.close();
    }
    this.loadingService.hideLoading();
  }

  close() {
    this.step = 1;
    this.isClosed = true;
    this.isDialogOpen = false;
    this.pdfObject = '';
  }

  @Watch('triggerDialogOpen')
  watchTriggerDialogOpen() {
    this.open();
  }
}
